import React from 'react'
import PropTypes from 'prop-types'
import {Button} from '@/components/cta'
import {buttonFunctions} from 'hec/builder/blocks/cta'
import {useDetermineRouteTypeAndUrl} from 'hec/hooks/useDetermineRouteTypeAndUrl'
import {getBreadcrumbLinkInputs} from './utils'
import {useFetchBuilderReference} from '@/builder/hooks/useFetchBuilderReference'

const BreadcrumbLink = (props) => {
    const {pageReference, label, isClickable, attributes, 'data-testid': dataTestId} = props
    const {className: attrClassName, ...restAttributes} = attributes || {}
    const disabled = !isClickable

    const shouldQueryPageData = !pageReference?.value

    const {data: pageData, error: pageDataError} = useFetchBuilderReference({
        model: 'page',
        shouldQuery: shouldQueryPageData,
        referenceId: pageReference?.id
    })

    if (pageDataError) {
        console.error('Error fetching page data for BreadcrumbLink: ', pageDataError)
    }

    const pageRef = shouldQueryPageData ? pageData?.data : pageReference?.value?.data
    const pageTitle = pageRef?.title

    const {url, routeType} = useDetermineRouteTypeAndUrl({
        clickFunction: buttonFunctions.linkToPage,
        isInternalLink: true,
        pageReference: pageRef
    })

    return (
        <Button
            ctaType="link"
            clickFunction={buttonFunctions.linkToPage}
            variant="breadcrumbLink"
            routeType={routeType}
            url={url}
            disabled={disabled}
            className={attrClassName}
            {...restAttributes}
            data-testid={dataTestId || 'breadcrumbLink'}
        >
            {label || pageTitle}
        </Button>
    )
}

BreadcrumbLink.propTypes = {
    separator: PropTypes.node,
    pageReference: PropTypes.shape({
        id: PropTypes.string.isRequired,
        value: PropTypes.shape({
            data: PropTypes.shape({
                title: PropTypes.string.isRequired,
                url: PropTypes.string.isRequired
            })
        })
    }),
    label: PropTypes.string,
    isClickable: PropTypes.bool,
    builderBlock: PropTypes.object,
    attributes: PropTypes.object,
    'data-testid': PropTypes.string
}

export const BreadcrumbLinkDefinition = {
    component: BreadcrumbLink,
    name: 'BreadcrumbLink',
    noWrap: true,
    inputs: getBreadcrumbLinkInputs()
}
